import { render, staticRenderFns } from "./SistemasClientes.vue?vue&type=template&id=6d720c59&scoped=true"
import script from "./SistemasClientes.vue?vue&type=script&lang=js"
export * from "./SistemasClientes.vue?vue&type=script&lang=js"
import style0 from "./SistemasClientes.vue?vue&type=style&index=0&id=6d720c59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d720c59",
  null
  
)

export default component.exports